module.exports = __webpack_public_path__ + "img/App book Literacy.no.9a1c87a0.png";